import { Coord } from "../../../../../../src/types/Interface";
import DrawAngleAnim from "../../../../../../src/animation/Intro/DrawAngleAnim";
import DrawAngleBgAnim from "../../../animations/DrawAngleBgAnimation";
import DrawCircleAnim from "../../../../../../src/animation/Intro/DrawCirleAnimation";
import DrawLineAnim from "../../../../../../src/animation/Intro/DrawLineAnimation";
import DrawPointAnim from "../../../../../../src/animation/Intro/DrawPointAnimation";
import RotateCircleAnim from "../../../../../../src/animation/Intro/RotateCircleAnim";
import SwapSprite from "../../../../../../src/animation/SwapSprite";
import ReduceOpacityAnim from "../../../animations/ReduceOpacityAnimation";
import Circle from "../../../../../../src/entities/Circle";
import Line from "../../../../../../src/entities/Line";
import AngleBg from "../../../entities/AngleBg";


export function drawPointAnim(point, coord: Coord): Promise<void> {
  return new Promise((resolve) => {
    point.draw(coord);
    point.scale = 0.2;
    new DrawPointAnim(point, () => resolve());
  })
}

export function drawAngleAnim(angle, value: string): Promise<void> {
  return new Promise((resolve) => {
    angle.visible = true;
    angle.scale.set(0.3);
    new DrawAngleAnim(angle, () => {
      angle.AngleValue.setValue(value);
      angle.AngleValue.visible = true;
      resolve();
    });
  });
}

export function drawLineAnim(line: Line, from: Coord, to: Coord): Promise<void> {
  return new Promise((resolve) => new DrawLineAnim(line, from, to, resolve));
}

export function drawCircleAnim(circle: Circle, radian: number, index: number, transparent: boolean, coord: Coord): Promise<void> {
  return new Promise((resolve) => new DrawCircleAnim(circle, radian, index, transparent, coord, resolve));
}

export function drawAngleBgAnim(AngleBg: AngleBg, radian: number, coord: Coord): Promise<void> {
  return new Promise((resolve) => new DrawAngleBgAnim(AngleBg, radian, coord, () => resolve()));
}

export function reduceOpacityAnim(angleBg: AngleBg): Promise<void> {
  return new Promise((resolve) => new ReduceOpacityAnim(angleBg, () => resolve()))
}

export function rotateCircleAnim(callback): Promise<void> {
  return new Promise((resolve) => new RotateCircleAnim(callback, resolve));
}

export function showCalcLineAnim(calcLine): Promise<void> {
  return new Promise(() => new SwapSprite(calcLine, .3, 1))
}

export function showSlidersAnim(SliderManager): Promise<void> {
  return new Promise(() => {
    SliderManager.showSliders();
    const sliders = SliderManager.getSliders();
    sliders.forEach(slider => new SwapSprite(slider, .3, 1))
  })
}